import { resourceListInit } from '../components/search/resourceList.js'
import { filtersModalInit } from '../components/search/components/filtersModal.js'
import { heroFilterPillsInit } from '../components/search/components/heroFilterPills.js'

resourceListInit()
filtersModalInit()
heroFilterPillsInit()